import React from 'react';
import { Button, Segmented, ConfigProvider } from 'antd';
import { ReloadOutlined, VideoCameraOutlined, AudioOutlined } from '@ant-design/icons';
import { ProjectNameInput } from './project-name-input';
import { SceneHeader } from './scene-header';
import { ScriptSection } from './script-section';
import { VestuarioSection } from './vestuario-section';
import { BackgroundSection } from './background-section';
import { PlanoSection } from './plano-section';
import { GenerateBar } from './generate-bar';
import { StatusTag } from '../../../../components/ui/status-tag';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { useEditorContext } from '../../context/editor-context';

type SceneModeValue = 'voice_video' | 'voice';

export const EditorPanel: React.FC = () => {
  const { scene, activeIndex, projectStatus, isProcessing, isValid, onGenerate, setSceneOnlyVoice } =
    useEditorContext();
  const { spacing, fontSize } = useResponsiveSizes();

  if (!scene) return null;

  const sceneMode: SceneModeValue = scene.onlyVoice ? 'voice' : 'voice_video';

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <ProjectNameInput />

      {projectStatus === 'failed' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: spacing.xs, marginBottom: spacing.md }}>
          <StatusTag label='Error al generar' />
          <Button
            type='link'
            icon={<ReloadOutlined />}
            onClick={onGenerate}
            disabled={!isValid}
            size='small'
            loading={isProcessing}
          >
            Reintentar
          </Button>
        </div>
      )}

      <SceneHeader />
      <div
        style={{
          background: C.bg,
          border: `1px solid ${C.border}`,
          borderRadius: 12,
          padding: spacing.lg
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: spacing.md,
            marginBottom: spacing.md
          }}
        >
          <span style={{ fontSize: fontSize.md, fontWeight: 500, color: C.textSecondary }}>Tipo de escena</span>
          <ConfigProvider
            theme={{
              token: { colorBgLayout: C.accentSurface },
              components: { Segmented: { itemSelectedBg: C.accent, itemSelectedColor: C.bg } }
            }}
          >
            <Segmented<SceneModeValue>
              value={sceneMode}
              onChange={v => setSceneOnlyVoice(activeIndex, v === 'voice')}
              options={[
                { label: 'Voz + Video', value: 'voice_video', icon: <VideoCameraOutlined /> },
                { label: 'Solo voz', value: 'voice', icon: <AudioOutlined /> }
              ]}
            />
          </ConfigProvider>
        </div>

        <ScriptSection />
        {!scene.onlyVoice && (
          <>
            <BackgroundSection />
            <VestuarioSection />
            <PlanoSection />
          </>
        )}
      </div>

      <div style={{ marginTop: spacing.md }}>
        <GenerateBar />
      </div>
    </div>
  );
};
